import "./Footer.css";

function Footer() {
  return (
    <div id="footer">
      <p>Developed by the University of Oxford, 2025</p>
    </div>
  );
}

export default Footer;
